// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__2N0hx","circle":"Loader_circle__BRIjg","opacity":"Loader_opacity__2OsAL"};